module.exports = __webpack_public_path__ + "img/1473480464.fc0287cf.jpg";